// Renders a looping muted video for uploaded files, or an embed iframe for YouTube/Instagram/etc.
export const MediaEmbed = ({ url, className = "", controls = false }) => {
  if (!url) return null;
  const isFile = /\.(mp4|webm|mov|m4v)(\?.*)?$/i.test(url) || url.includes("/api/files/");

  if (isFile) {
    return (
      <video
        src={url}
        className={className}
        autoPlay
        muted
        loop
        playsInline
        controls={controls}
        data-testid="media-video"
      />
    );
  }

  let embed = url;
  const yt = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/);
  if (yt) {
    embed = `https://www.youtube.com/embed/${yt[1]}?autoplay=1&mute=1&loop=1&playlist=${yt[1]}&controls=0&playsinline=1&modestbranding=1&rel=0`;
  } else if (url.includes("instagram.com/") && !url.includes("/embed")) {
    embed = url.replace(/\/?$/, "/") + "embed";
  }
  return (
    <iframe
      src={embed}
      className={className}
      allow="autoplay; encrypted-media; picture-in-picture"
      allowFullScreen
      title="video"
      frameBorder="0"
      data-testid="media-embed"
    />
  );
};
